import Locale from "@/utils/locale";
import En from "@/locale/en-us";
import Zh from "@/locale/zh-cn";

export default defineNuxtPlugin((nuxtApp) => {
  // 注册国际化资源 key改为和组件库一致
  Locale.add({
    "en": En,
    "zh": Zh,
  });

  // 在 Nuxt 3 中使用 nuxtApp.vueApp 代替 Vue
  // @ts-ignore
  nuxtApp.vueApp.use(Locale);
  
  // 提供 $t 方法给 useNuxtApp()，让 setup 中也能使用
  return {
    provide: {
      t: Locale.t,
    },
  };
});
